// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var ReactSelect = require("react-select");
var Caml_splice_call = require("rescript/lib/js/caml_splice_call.js");
var JsxRuntime = require("react/jsx-runtime");

var Types = {};

function combineManyStyles(styles) {
  return Caml_splice_call.spliceApply(Object.assign, [Belt_Array.concatMany([
                    [{}],
                    styles
                  ])]);
}

var Styles = {
  combineManyStyles: combineManyStyles
};

var ClassNames = {};

function wrapOption(option) {
  return {
          wrapped: option
        };
}

function unwrapOption(option) {
  return option.wrapped;
}

var Options = {
  wrapOption: wrapOption,
  unwrapOption: unwrapOption
};

var Props = {};

var Single = {};

var Multi = {};

var Plain = {
  Single: Single,
  Multi: Multi
};

var Single$1 = {};

var Multi$1 = {};

var Grouped = {
  Single: Single$1,
  Multi: Multi$1
};

var Select = {
  Plain: Plain,
  Grouped: Grouped
};

var Single$2 = {};

var Multi$2 = {};

var Plain$1 = {
  Single: Single$2,
  Multi: Multi$2
};

var Single$3 = {};

var Multi$3 = {};

var Grouped$1 = {
  Single: Single$3,
  Multi: Multi$3
};

var Async = {
  Plain: Plain$1,
  Grouped: Grouped$1
};

var Single$4 = {};

var Multi$4 = {};

var Plain$2 = {
  Single: Single$4,
  Multi: Multi$4
};

var Single$5 = {};

var Multi$5 = {};

var Grouped$2 = {
  Single: Single$5,
  Multi: Multi$5
};

var AsyncCreatable = {
  Plain: Plain$2,
  Grouped: Grouped$2
};

var make = ReactSelect.components.Input;

var Input = {
  make: make
};

function make$1(props) {
  var newrecord = Caml_obj.obj_dup(props);
  return JsxRuntime.jsx(make, (newrecord.onPaste = props.selectProps.onPaste, newrecord));
}

var Input$1 = {
  Input: Input,
  make: make$1
};

exports.Types = Types;
exports.Styles = Styles;
exports.ClassNames = ClassNames;
exports.Options = Options;
exports.Props = Props;
exports.Select = Select;
exports.Async = Async;
exports.AsyncCreatable = AsyncCreatable;
exports.Input = Input$1;
/* make Not a pure module */
